import React, {Component} from 'react'
import {observer} from 'mobx-react'
import ExportPvz from './export_filters/ExportPvz'
import ImportPvz from './import_filters/ImportPvz'
import Label from '../core/container/Label'
import HorizontalLabelList from '../core/container/HorizontalLabelList'

@observer export default class ImportExportPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			type: 'export',
			is_lock: false
		}
	}

	render() {
		const context = this.props.context
		const marginTopStyle = window.shop_pokupki_ui_version !== '2.0' ? '-20px' : '0px';

		return (
			<div className="form fields custom-mt-24" style={{overflow: 'hidden', marginTop: marginTopStyle}}>
				<div className="field-group" >
					<div className="field">
						<div className="name">
							Выбрать
						</div>
						<div className="value">
							<HorizontalLabelList>
								<Label
									control={
										<input
											type="radio"
											checked={this.state.type === 'export'}
											onChange={e => !this.state.is_lock && e.target.checked && this.setState({
												type: 'export'
											})}
										/>
									}
								>
									Экспорт
								</Label>
								<Label
									control={
										<input
											type="radio"
											checked={this.state.type === 'import'}
											onChange={e => !this.state.is_lock && e.target.checked && this.setState({
												type: 'import'
											})}
										/>
									}
								>
									Импорт
								</Label>
							</HorizontalLabelList>
						</div>
					</div>
					<div className="clear" />

					{this.state.type === 'export' && (
						<ExportPvz
							context={context}
							onChangeState={(state) => this.setState({
								is_lock: state === 'process'
							})}
						/>
					)}

					{this.state.type === 'import' && (
						<ImportPvz
							context={context}
							onChangeState={(state) => this.setState({
								is_lock: state === 'process'
							})}
						/>
					)}
				</div>
			</div>
		);
	}
}